import { Controller } from '@hotwired/stimulus';
const axios = require('axios');

export default class extends Controller {
	static targets = [
		'container',
		'form',
		'video',
		'selectAllButton',
		'disabledButtonContainer',
		'submitButtonContainer',
		'errorMessage',
		'stickyMobileButton',
		'stickyMobileButtonContainer',
		'progressBar',
		'progressBarCount',
	];

	connect() {
		// this.application.getControllerForElementAndIdentifier();
		// document.addEventListener('DOMContentLoaded', () => {
		// 	this.toggleStickyMobileButton();
		// });
		// document.addEventListener('scroll', () => {
		// 	this.toggleStickyMobileButton();
		// });
	}

	openModal(e) {
		e.preventDefault();

		this.accountModalController.open();
	}

	/**
	 * Get account modal controller to perform actions on.
	 *
	 * Useage: this.accountModalController.open()
	 */
	get accountModalController() {
		return this.application.getControllerForElementAndIdentifier(document.querySelector('[data-controller="account-modal"]'), 'account-modal');
	}

	submit(e) {
		e.preventDefault();

		if (this.formTarget.getAttribute('data-session-consent') !== 'true') {
			this.accountModalController.open();
		} else {
			const formData = new FormData(this.formTarget);

			formData.append('action', 'emerce_tv_submit_watchlist');

			this.formTarget.setAttribute('data-group-loading', true);

			axios
				.post(mainScriptData.ajaxUrl, formData)
				.then((response) => {
					if (response.data.status == 'success') {
						window.location.href = response.data.redirect;
					}

					if (response.data.status == 'error') {
						this.errorMessageTargets.forEach((errorMessage) => {
							errorMessage.innerHTML = response.data.message;
							errorMessage.classList.remove('hidden');
						});

						// Disable loader
						this.formTarget.removeAttribute('data-group-loading');
					}
				})
				.catch((error) => {
					console.log(error);

					// Disable loader on error
					this.formTarget.removeAttribute('data-group-loading');
				});
		}
	}

	toggleSelectAll(e) {
		e.preventDefault();

		// Toggle all videos
		if (e.currentTarget.getAttribute('data-group-toggle')) {
			e.currentTarget.removeAttribute('data-group-toggle');

			this.videoTargets.forEach((video) => {
				if (video.getAttribute('data-group-toggle')) {
					video.click();
				}
			});
		} else {
			e.currentTarget.setAttribute('data-group-toggle', true);

			this.videoTargets.forEach((video) => {
				if (!video.getAttribute('data-group-toggle')) {
					video.click();
				}
			});
		}
	}

	toggleSelection(e) {
		const video = e.currentTarget.closest('label');

		// Toggle video selection
		if (video.getAttribute('data-group-toggle')) {
			video.removeAttribute('data-group-toggle');
		} else {
			video.setAttribute('data-group-toggle', true);
		}

		// Clear error messages on changing selection
		this.errorMessageTargets.forEach((errorMessage) => {
			errorMessage.classList.add('hidden');
		});

		// Check select all button if all videos are checked
		if (this.allVideosChecked()) {
			this.selectAllButtonTargets.forEach((selectAllButton) => {
				selectAllButton.setAttribute('data-group-toggle', true);
			});
		} else {
			this.selectAllButtonTargets.forEach((selectAllButton) => {
				selectAllButton.removeAttribute('data-group-toggle');
			});
		}

		if (this.atLeastOneVideoChecked()) {
			this.disabledButtonContainerTargets.forEach((disabledButtonContainer) => {
				disabledButtonContainer.classList.add('hidden');
			});

			this.submitButtonContainerTargets.forEach((submitButtonContainer) => {
				submitButtonContainer.classList.remove('hidden');
			});
		} else {
			this.disabledButtonContainerTargets.forEach((disabledButtonContainer) => {
				disabledButtonContainer.classList.remove('hidden');
			});

			this.submitButtonContainerTargets.forEach((submitButtonContainer) => {
				submitButtonContainer.classList.add('hidden');
			});
		}

		this.updateProgressBar();
	}

	allVideosChecked() {
		let allVideosChecked = true;

		this.videoTargets.forEach((video) => {
			if (!video.querySelector('input').checked) {
				allVideosChecked = false;
			}
		});

		return allVideosChecked;
	}

	atLeastOneVideoChecked() {
		let atLeastOneVideoChecked = false;

		this.videoTargets.forEach((video) => {
			if (video.querySelector('input').checked) {
				atLeastOneVideoChecked = true;
			}
		});

		return atLeastOneVideoChecked;
	}

	toggleStickyMobileButton(e) {
		if (this.isInViewport(this.stickyMobileButtonContainerTarget)) {
			this.stickyMobileButtonTarget.removeAttribute('data-toggle');
		} else {
			this.stickyMobileButtonTarget.setAttribute('data-toggle', true);
		}
	}

	updateProgressBar() {
		let checkedVideosCount = 0;

		this.videoTargets.forEach((video) => {
			if (video.querySelector('input').checked) {
				checkedVideosCount++;
			}
		});

		this.containerTarget.setAttribute('data-checked-videos-count', checkedVideosCount);
		const videosCount = parseInt(this.containerTarget.getAttribute('data-videos-count'));
		const progressPercentage = Number(checkedVideosCount / videosCount).toFixed(2);

		this.progressBarTarget.style.transform = 'scaleX(' + progressPercentage + ')';
		this.progressBarCountTarget.innerHTML = checkedVideosCount;
	}

	isInViewport(elem) {
		var bounding = elem.getBoundingClientRect();
		return bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight);
	}
}
